<template>
  <div>
    <div class="product-window" :class="attr.cartAttr === true ? 'on' : ''">
      <div class="textpic acea-row row-between-wrapper">
        <div class="pictrue">
          <img :src="attr.image" class="image" />
        </div>
        <div class="text">
          <div class="line1">
            {{ attr.name }}
          </div>
          <div class="money font-color-red">
            ₱<span class="num">1</span
            ><span class="stock">Inventory: {{ attr.stock }}</span>
          </div>
        </div>
        <div class="iconfont icon-guanbi" @click="closeAttr"></div>
      </div>

      <div class="cart">
        <div class="cart-left">
          <div class="title">Quantity</div>
          <div class="carnum acea-row row-left">
            <div
                    class="item reduce"
                    :class="attr.cart_num <= 1 ? 'on' : ''"
                    @click="CartNumDes"
            >
              -
            </div>
            <!--<div class="item num">{{ attr.productSelect.cart_num }}</div>-->
            <input  class="item num" type="number"  v-model="attr.cart_num" value="attr.cart_num" >
            <div
                    class="item plus"
                    :class="
              attr.cart_num >= attr.stock
                ? 'on'
                : ''
            "
                    @click="CartNumAdd"
            >
              +
            </div>
          </div>
        </div>
        <div class="cart-right">
          <p> Total price:₱{{(attr.cart_num).toFixed(2)}}</p>
        </div>
      </div>

    </div>
    <div
      class="mask"
      @touchmove.prevent
      :hidden="attr.cartAttr === false"
      @click="closeAttr"
    ></div>
  </div>
</template>
<script>
export default {
  name: "ProductWindow",
  props: {
    attr: {
      type: Object,
      default: () => {}
    },


  },
  data: function() {
    return {
    };
  },
  mounted: function() {},
  watch:{
    'attr.cart_num':function (val) {
      if(val>this.attr.stock){
        this.attr.cart_num = this.attr.stock
      }
    }
  },
  methods: {


     closeAttr: function() {
      this.$emit("changeFun", { action: "changeattr", value: false });
    },
    CartNumDes: function() {
      this.$emit("changeFun", { action: "ChangeCartNum", value: false });
    },
    CartNumAdd: function() {
      this.$emit("changeFun", { action: "ChangeCartNum", value: 1 });
    },


  }
};
</script>
<style>
  .cart{
    display: flex;
    justify-content: space-between;
  }
  .cart-left{

  }
  .cart-right{
    text-align: right;
    padding-top: 0.42rem;
    box-sizing: border-box;
    color: #f73e46;
  }
  .auto-type{
    margin-top: 0.36rem;
    padding: 0 0.3rem;

  }
  .auto-type .title{
    font-size: 0.3rem;
    color: #999;
    margin-bottom: 12px;
  }
  .auto-type .type-list{
    display: flex;
    justify-content:space-around;

  }
  .auto-type .type-item{
    border: 1px solid #A4A4A4;
    border-radius: 3px;
    padding: 3px 5px;
    color: #666;
  }
  .auto-type .choose{
    color: #00c3f9;
    border-color: #00c3f9;
  }


</style>
